import { CircleCheck } from 'lucide-react';
import { ClassSession } from 'modules/jogador/classes/types';

interface SessionRowProps {
  session: ClassSession;
}

export function SessionRow({ session }: SessionRowProps) {
  return (
    <div className="flex items-center gap-4 rounded-xl border border-border/70 bg-surface p-3">
      <div className="flex w-12 flex-col items-center">
        <span className="text-xs font-semibold text-ink-secondary">{session.day}</span>
        <span className="font-heading text-lg font-bold text-ink">{session.dateLabel}</span>
      </div>

      <div className="flex-1">
        <p className="font-medium text-ink">
          {session.timeLabel} · {session.court}
        </p>
        <p className="text-sm text-ink-secondary">
          {session.className} · {session.attendanceLabel}
        </p>
      </div>

      <CircleCheck className="h-5 w-5 text-success" aria-label="Presença confirmada" />
    </div>
  );
}
